import { AppContext, Features } from "@lightspeed-invoicing/core-client/frontend";
import $ from 'jquery';
import React, { Component } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import GlobalHelper from '../../common/GlobalHelper.jsx';
import Icon from "../../common/icon/icon.component.jsx";
import LocationSelect from "../../integration/LocationSelect";
import TestModeAlert from "../../payment-processing/components/TestModeAlert";
import Location from "../../state/location/Location";
import OnlinePayment from "./online-payment.component.jsx";

class NewCreditCardModal extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            modalId: this.props.modalId || 'credit-card-modal',
            contactId: this.props.contactId || '',
            myAccountBilling: this.props.myAccountBilling || false,
            countryCode: GlobalHelper.getCountryCodeFromCurrency(AppContext.getCurrency()),
            creditCardError: '',
            onSubmit: this.props.onSubmit || function () { },
            currency: '',
            publicKey: '',
            integrationKey: '',
            testMode: false,
            saveAndChargeLater: this.props.saveAndChargeLater || false,
            locationId: this.props.locationId,
            selectedLocation: null,
            locationsFetched: false,
            locations: []
        }
        this.closeModal = this.closeModal.bind(this)
        this.handleSubmitNewCard = this.handleSubmitNewCard.bind(this)
        this.refreshContact = this.refreshContact.bind(this)
    }

    componentDidMount() {
        $('#' + this.state.modalId).modal('show')
        if (this.state.myAccountBilling) {
            AppContext.getApiClient().get('/accounts/billing/payment-integration-public-api-keys').then(r => {
                this.setState({
                    publicKey: r?.attributes?.publicApiKey || '',
                    integrationKey: r.attributes.integrationKey,
                    currency: AppContext.getAccount().attributes.currency,
                    testMode: r.attributes.testMode,
                    loading: false,
                })
            })
        }
        if (!this.props.locationId) {
            this.setState({
                loading: true,
            })
            AppContext.getApiClient().get('/locations').then(r => {
                const locations = r.data.filter(loc => {
                    return loc.attributes.enabled && GlobalHelper.isLocationAssignedToIntegrationKey(loc.id, GlobalHelper.getFirstIntegrationKeyFoundWithEnabledFeature(Features.IntegratedPayment))
                })
                this.setState({
                    locations: locations,
                    loading: false,
                    locationsFetched: true
                })
            }
            )
        }
    }


    handleSubmitNewCard(setupIntent, token, saveCard, error, next) {
        if (setupIntent && setupIntent.error) {
            this.setState({
                creditCardError: <div className={"col-12"}>
                    <small className={"text-danger"}>{setupIntent.error.message}</small>
                </div>,
            })
            next()
        } else if (error) {
            this.setState({
                creditCardError: <div className={"col-12"}>
                    <small className={"text-danger"}>{error.message}</small>
                </div>
            })
            next()
        }
        else if (setupIntent && setupIntent.setupIntent) {
            this.submit(setupIntent.setupIntent.payment_method, saveCard, res => {
                if (res.error) {
                    this.setState({
                        creditCardError: <div className={"col-12"}>
                            <small className={"text-danger"}>{res.error.message}</small>
                        </div>
                    })
                }
                next()
            })
        } else if (token) {
            this.submitWithToken(token, res => {
                if (res.error) {
                    this.setState({
                        creditCardError: <div className={"col-12"}>
                            <small className={"text-danger"}>{res.error.message}</small>
                        </div>
                    })
                }
                next()
            })
        }
    }

    submitWithToken(integrationToken, next) {
        let data = {}
        if (integrationToken) {
            data.creditCard = {
                savedCardToken: integrationToken.savedCardToken || '',
                singleUseToken: integrationToken.token || '',
                saveCard: integrationToken.saveCard,
                paymentFlow: 'token',
            }
            if (integrationToken.billingDetails) {
                data.billingDetails = integrationToken.billingDetails
            }
            if (this.state.locationId) {
                data.locationId = this.state.locationId
            }
            data.fingerprintId = GlobalHelper.getFingerprintId()
            let url = `/contacts/${this.state.contactId}/cards-on-file`
            if (this.state.myAccountBilling) {
                url = '/accounts/billing/cards-on-file'
            }
            AppContext.getApiClient().post(url, data).then(res => {
                if (next) {
                    next(res)
                }
                if (!res.error) {
                    this.state.onSubmit(this.state.contactId)
                    this.closeModal()
                }
            })
        }
    }

    submit(externalPaymentMethodId, saveCard, next) {
        let data = {}
        if (externalPaymentMethodId) {
            data.creditCard = {
                saveCard,
                savedCardToken: externalPaymentMethodId,
                paymentFlow: 'payment-intent',
            }
            data.fingerprintId = GlobalHelper.getFingerprintId()
            if (this.state.locationId) {
                data.locationId = this.state.locationId
            }
            let url = `/contacts/${this.state.contactId}/cards-on-file`
            if (this.state.myAccountBilling) {
                url = '/accounts/billing/cards-on-file'
            }
            AppContext.getApiClient().post(url, data).then(res => {
                if (next) {
                    next(res)
                }
                if (!res.error) {
                    this.state.onSubmit(this.state.contactId)
                    this.closeModal()
                }

            })
        }
    }

    closeModal(event) {
        event?.preventDefault()
        $('#' + this.state.modalId).modal('hide')
        if (this.props.onClose) {
            this.props.onClose(event)
        }
    }

    refreshContact() {
        this.state.onSubmit(this.state.contactId)
        this.closeModal()
    }

    render() {
        return (
            <div className="modal fade"
                id={this.state.modalId}
                role="dialog"
                aria-labelledby="creditCardModalTitle"
                data-backdrop="static"
                data-keyboard="false"
            >
                <div className="modal-dialog modal-md" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title mb-0 border-0 pb-0" id="creditCardModalTitle">
                                <Icon value={'credit-card'} className={'mr-2'} />
                                <FormattedMessage
                                    id="customers.cards_on_file.modal_header_label"
                                    defaultMessage="Add a credit card on file"
                                />
                            </h5>
                            <button type="button" className="close" onClick={this.closeModal} aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        {(!this.props.locationId && AppContext.locations.length > 0) && <div className="modal-body pt-2 px-0 pb-1">
                            <div className='modal-body px-4 pt-2'>
                                {this.state.locations.length == 0 && this.state.locationsFetched ?
                                    <FormattedMessage
                                        id='customer.bank_account_on_file.no_locations'
                                        defaultMessage='Enable or assign locations to the payment integration to add a new payment method.'
                                    /> : <>
                                        <label className="ml-1 mb-0">
                                            <FormattedMessage
                                                id="invoice.listing.headers.location_label"
                                                defaultMessage="Location"
                                            />
                                        </label>
                                        <LocationSelect
                                            locations={this.state.locations.map(
                                                (loc) => new Location(loc)
                                            )}
                                            selectedLocationIds={this.state.selectedLocation}
                                            isLoadingLocations={this.state.loading}
                                            onSelect={(selectedlocation) => {
                                                this.setState({
                                                    locationId: selectedlocation.value,
                                                    selectedLocation: selectedlocation,
                                                });
                                            }}
                                            multi={false}
                                        />
                                    </>
                                }
                            </div>
                        </div>}
                        {(this.state.locationId || AppContext.locations.length === 0) &&
                            <div className={"modal-body pt-0 px-4 " + ((this.props.locationId || AppContext.locations.length === 0) ? "pt-3" : "pt-0")}>
                                <TestModeAlert />
                                <OnlinePayment
                                    countryCode={this.state.countryCode}
                                    onSubmit={this.handleSubmitNewCard}
                                    refreshContact={this.refreshContact}
                                    showSaveCardComponent={true}
                                    submitButton={<FormattedMessage
                                        id="customers.cards_on_file.list.add_card_btn"
                                        defaultMessage="Add"
                                    />}
                                    onClose={this.closeModal}
                                    submitDisabled={false}
                                    forceSaveCard={true}
                                    publicKey={this.state.publicKey}
                                    integrationKey={this.state.integrationKey}
                                    testMode={this.state.testMode}
                                    saveAndChargeLater={this.state.saveAndChargeLater}
                                    contactId={this.state.contactId}
                                    myAccountBilling={this.state.myAccountBilling}
                                    locationId={this.state.locationId}
                                />
                                {this.state.creditCardError}
                            </div>}
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" onClick={this.closeModal}>
                                <FormattedMessage
                                    id="common.email.modal.close_btn"
                                    defaultMessage="Close"
                                />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(NewCreditCardModal)





// WEBPACK FOOTER //
// ./src/common/credit-card/newcreditcardmodal.component.jsx